// @file UI-only store for the Surface Live panel scaffold
import { unboundedWatch } from '@@/bits/vue'
import { useSurfaceLiveActivityStore } from '@@/pinia/surface_live_activity_store'
import { useSurfacePermissionsStore } from '@@/pinia/surface_permissions'
import { useSurfaceSidePanelsStore } from '@@/pinia/surface_side_panels'
import { defineStore } from 'pinia'
import { computed } from 'vue'

const useSurfaceLivePanelStore = defineStore('surfaceLivePanel', () => {
  const sidePanelsStore = useSurfaceSidePanelsStore()
  const liveActivityStore = useSurfaceLiveActivityStore()
  const permissionsStore = useSurfacePermissionsStore()
  // Open state lives on the side-panel registry so only one docked panel can be active.
  const xSurfaceLivePanel = computed(() => sidePanelsStore.isSidePanelOpen('live'))

  const canISeeLivePanel = computed(() =>
    liveActivityStore.activityStatus === 'running' ? liveActivityStore.isCreator : permissionsStore.canIAdminister,
  )

  function closeLivePanel(): void {
    sidePanelsStore.closeSidePanel('live')
  }

  function openLivePanel(): void {
    sidePanelsStore.openSidePanel('live')
  }

  function toggleLivePanel(): void {
    sidePanelsStore.toggleSidePanel('live')
  }

  void unboundedWatch(canISeeLivePanel, (visible) => {
    if (!visible) closeLivePanel()
  })

  return { xSurfaceLivePanel, canISeeLivePanel, openLivePanel, closeLivePanel, toggleLivePanel }
})

export { useSurfaceLivePanelStore }
